var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sample-psi",attrs:{"id":_vm.samplePsiId}},[_c('svg')])}
var staticRenderFns = []

export { render, staticRenderFns }